window.SAAffiliation = {

	prepareCommissionsFilterForm : function(listingName){
		Corporation.autoCorporation($('#'+listingName+'Listing_filter_corpid'), 1, {}, function(){Listing.update(listingName)});
		Corporation.autoCorporation($('#'+listingName+'Listing_filter_affiliateid'), 1, {}, function(){Listing.update(listingName)});

		var options = {success:function(data){SAAffiliation.processCommissionsFilterForm(data);}, dataType:"json"};
        MyForm.prepare(listingName+'FilterForm', "sellsyadmin_affiliation&action=updateCommissions", options);
	},

	processCommissionsFilterForm: function(data){
		Listing.refresh(data.prefix+"Listing", data, data.sellsyadmin_commissions_metadatas);
    },

	prepareRemunerationsFilterForm : function(listingName){

		Corporation.autoCorporation($('#'+listingName+'Listing_filter_corpid'), 1, {}, function(){Listing.update(listingName)});

        var options = {success:function(data){SAAffiliation.processRemunerationsFilterForm(data);}, dataType:"json"};
        MyForm.prepare(listingName+'FilterForm', "sellsyadmin_affiliation&action=updateRemunerations", options);
	},

	processRemunerationsFilterForm: function(data){
		Listing.refresh(data.prefix+"Listing", data, data.sellsyadmin_remunerations_metadatas);
    },


	checkCommission	: function(commissionID){

		var formID	= 'affilCommissionForm';

		var options = {
			title	 : Loc.g('Validation commission'),
			width	 : 700,
			callback : function(data){

				var formOpts = {
					data : {
						action			: 'recordCommissionForm',
						commissionID	: commissionID
					},
					dataType : 'json',
					success	 : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);

						if(formOk){
							Listing.update($('#listingname').val());
							MyWindow.close();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_affiliation', formOpts, true);
				MyFacture.customForm();
			},
			buttons  : [
				{
					text	: Loc.g('Annuler'),
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Valider'),
					click	: function(){ $('#'+formID).submit(); }
				}
			]
		};


		MyWindow.load('sellsyadmin_affiliation',{action : 'checkCommissionForm', commissionID : commissionID, validAction : 'accept'}, options);
	},

	refuseCommission		: function(commissionID){
		var formID	= 'affilCommissionForm';

		var options = {
			title	 : Loc.g('Refus commission'),
			width	 : 700,
			callback : function(data){

				var formOpts = {
					data : {
						action			: 'recordRefuseCommissionForm',
						commissionID	: commissionID
					},
					dataType : 'json',
					success	 : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);

						if(formOk){
							Listing.update($('#listingname').val());
							MyWindow.close();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_affiliation', formOpts, true);
			},
			buttons  : [
				{
					text	: Loc.g('Annuler'),
					click	: function(){ $(this).dialog('close'); }
				}, {
					text	: Loc.g('Valider'),
					click	: function(){ $('#'+formID).submit(); }
				}
			]
		};


		MyWindow.load('sellsyadmin_affiliation',{action : 'checkCommissionForm', commissionID : commissionID, validAction : 'refuse'}, options);
	},

	setCommissionStep : function(step, commissionID){

		MyFacture.post('sellsyadmin_affiliation',
			{
				action		: 'setCommissionStep',
				commissionID: commissionID,
				step		: step
			},
			function (data) {
				if (data.status === 'ok') {
					Listing.update($('#listingname').val(), true);
				}
			},
			'json'
		);

	},

	createRemFromCom : function(commissionID){

		MyFacture.post('sellsyadmin_affiliation', {
			action		: 'createRemunerationFromCommission',
			commissionID: commissionID
		}, function(data){
			if(data.status == 'success') {
				Push.success(Loc.g('La rémunération a bien été créée'), Loc.g('Succès'));
				Listing.update();
			} else {
				Push.error((data.message ? Loc.g(data.message) : Loc.g('Une erreur est survenue')), Loc.g('Erreur'));
			}
		}, 'json');

	},

	checkRemunerationForm	: function(remunerationID){

		var formID	= 'checkRemunerationForm';

		var options = {
			title	 : Loc.g('Validation rémunération'),
			width	 : 700,
			callback : function(data){

				var formOpts = {
					data : {
						action			: 'recordRemunerationForm',
						remunerationID	: remunerationID,
					},
					dataType : 'json',
					success	 : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);

						if(formOk){
							Listing.update($('#listingname').val());
							MyWindow.close();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_affiliation', formOpts, true);
			},
			buttons  : [
				{
					text 	: 'Annuler',
					click 	: function(){ $(this).dialog('close'); }
				}, {
					text 	: Loc.g('Valider'),
					click 	: function(){ $('#'+formID).submit(); }
				}
			]
		};


		MyWindow.load('sellsyadmin_affiliation',{action : 'checkRemunerationForm', remunerationID : remunerationID}, options);
	},

	commissionForm : function(){
		var formID	= 'commissionForm';

		var options = {
			title	 : Loc.g('Ajouter une commission'),
			width	 : 700,
			callback : function(data){

				MyFacture.customForm('#'+formID);

				Corporation.autoCorporation($('#affiliateid'), 1, {}, function(item){
					$('#related_entity').show().find('label, .form-input').empty();
					let billingSettings;

					$.ajax({
						type	: 'GET',
						url		: '/rest/sellsy-account-manager/corporation/' + item.id + '/billing-settings',
						async	: false,
						dataType: 'json',
						success : function(data){
							billingSettings = data;
						}
					});

					if (billingSettings?.billingProvider === 'chargebee') {
						$('#related_entity > label').html(Loc.g('Commentaire'));
						$('#related_entity > .form-input').append('<input type="text" name="note" id="note" value="" placeholder="Chargebee #132" />');
					} else {
						$('#related_entity > label').html(Loc.g('Facture'));
						$('#related_entity > .form-input').append('<input type="text" name="invoiceid" id="invoiceid" value="" e_autodoc_max="1" e_autodoc="invoice" e_autodoc_more="third_' + item.thirdid +'" e_autodoc_searchonfocus="Y" e_autodoc_sel="SAAffiliation.chooseDocument(item)"/>');
						MyFacture.customForm('#related_entity');
					}
				},
				function(item){
					$('#related_entity').hide();
				});

				Corporation.autoCorporation($('#corpid'), 1, {}, function(item){
					$('#commissionRate').val(item.affilv2Rate);
					$('.affiliatesCount').text(item.affilv2NbAffiliates+" filleuls payants").show();
					$('#affiliateid').tokenInput('more', {filter:{utmSource:'affiliation', utmCampaign:item.id}});
				},
				function(item){
					$('#commissionRate').val("0");
					$('.affiliatesCount').empty().hide();
					$('#affiliateid').tokenInput('more', {filter:{utmSource:'affiliation', utmCampaign:0}});
					$('#affiliateid').tokenInput('clear');

					$('#provisionid').empty();
					$('#provisionid').append('<option value="">Choisir une provision...</option>');
				});


				var formOpts = {
					data : {
						action			: 'recordCommission',
					},
					dataType : 'json',
					success	 : function(data){
						var formOk = MyForm.processJson(data, data.form.formId);

						if(formOk){
							Listing.update($('#listingname').val());
							MyWindow.close();
						}
					}
				};

				MyForm.prepare(formID, 'sellsyadmin_affiliation', formOpts, true);
			},
			buttons  : [
				{
					text : Loc.g('Annuler'),
					click : function(){ $(this).dialog('close'); }
				}, {
					text : Loc.g('Valider'),
					click : function(){ $('#'+formID).submit(); }
				}
			]
		};

		MyWindow.load('sellsyadmin_affiliation',{action : 'commissionForm'}, options);
	},

	chooseDocument: function (document) {
		SAAffiliation.feedCommissionForm({
			amount: document.totalAmountTaxesFree,
			invoiceid: document.docid,
			currency: document.currency,
		});
	},

	chooseProvision: function () {
		var chosen = $('#provisionid option:selected');
		SAAffiliation.feedCommissionForm({
			amount: chosen.data('amount'),
			invoiceid: chosen.data('invoiceid'),
			currency: chosen.data('currency'),
		});
	},

	feedCommissionForm: function(data) {
		var amount = data.amount || 0;
		$('#paymentAmount').val(amount);
		$('#easybillInvoiceId').val(data.invoiceid);
		$('#currencyid').val(data.currency);
		SAAffiliation.computeCommissionAmount();
	},

	computeCommissionAmount: function() {
		var numformat 	= NumberFormat.load(false, 'num_');
		var parrainRate = parseInt($('#commissionRate').val(), 10);
		var commission 	= $('#paymentAmount').val() * (parrainRate / 100);

		$('#commissionAmount').val(NumberFormat.formatToDisplay(commission, numformat));
	}

};
